import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './HeatAndGas.module.scss';

export const HeatAndGas = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/heat-and-gas/header-heat-and-gas.png"
        imageAlt="Heat and Gas Services banner image"
        title="Heating & Gas"
      />

      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Gas & Central Heating Engineers in London"
                  description="From installations to repairs, our experienced Central Heating Engineers provide reliable central heating services. Find expert boiler fitters and gas engineers near you for efficient and professional solutions"
                />

                <CTAButton
                  title="Book a Heating Engineer"
                  serviceName="Heating & Gas"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Boiler Services"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/heat-and-gas/boiler-repair.webp"
                      imgAlt="Boiler Repairs"
                      title="Boiler Repairs"
                      description="A broken boiler can bring your whole home to a freezing halt. Our heating engineers specialise in fast and effective boiler repairs, ensuring you don’t have to shiver through a cold night. Whether it's a full-blown emergency or just a minor hiccup, our experts are on it—diagnosing and fixing the problem to keep your home warm and cosy."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/heat-and-gas/boiler-servicing.webp"
                      imgAlt="Boiler Servicing"
                      title="Boiler Servicing"
                      description="Regular boiler servicing is essential for keeping your heating system running smoothly and preventing unexpected breakdowns. Our central heating engineers offer thorough boiler servicing, keeping your system in top shape and extending its lifespan. Stay warm and save money with our reliable servicing solutions."
                    />
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/heat-and-gas/boiler-installation.webp"
                      imgAlt="Boiler Installation"
                      title="Boiler Installation"
                      imgObjectFit="cover"
                      description="Looking to upgrade your old boiler or install a new one? Our experienced boiler fitters near you provide top-notch boiler installation services, ensuring your new system is installed safely and efficiently. We offer expert advice on the best options for your home, so you get a system that fits your needs and keeps you warm without hassle."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.root}>
        <EmergencyComponent
          title="Heating and Gas Engineers"
          imageSrc="/images/services/heat-and-gas/emergency-heat-gas.jpeg"
          imageAlt="Emergency heat and gas services"
          styles={styles}
          para1="No one likes the chill of a broken boiler, especially in the middle of winter. Our central heating engineers in London provide reliable solutions for all your heating needs, whether it's an urgent repair, routine servicing, or a complete new installation."
          para2="Trust our London-based gas engineers to bring the heat (literally) with high-quality heating services to keep you cosy all year round. Available 7 days a week for your convenience."
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'Boiler fault finding' },
            { name: 'Boiler repairs' },
            { name: 'Boiler installation' },
            { name: 'Gas appliance repairs' },
            { name: 'Gas appliance installation' },
            { name: 'Gas safety certificates (GSC)' },
            { name: 'Boiler servicing' },
            { name: 'Gas leaks' },
            { name: 'Central heating controls' },
            { name: 'Thermostats' },
            { name: 'Central heating pumps' },
            { name: 'Central heating repairs' },
            { name: 'Power flushes' },
            { name: 'Radiator leaks' },
            { name: 'Radiator valves' },
            { name: 'Emergency gas engineer' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes styles={styles} mainPageUrl="/services/heating-and-gas" />
        <FAQsView title="Boiler FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};

const faqItems = [
  {
    title: 'How often should I service my boiler?',
    details: `It's recommended to service your boiler once a year to ensure it runs safely and efficiently. Annual servicing helps prevent unexpected issues and prolongs the life of your boiler.`,
  },
  {
    title: 'What are the signs my boiler needs a repair?',
    details:
      'Strange noises, low pressure, inconsistent heating, a yellow flame instead of blue, or frequent error codes can all indicate that your boiler needs a repair. If you notice any of these signs, contact our qualified heating engineer.',
  },
  {
    title: 'What type of boiler is best for my home?',
    details: `The ideal boiler depends on the size of your home, your water usage, and heating needs. Combi boilers are compact and great for smaller homes, while system or regular boilers are better suited for larger properties. Our heating engineers can help you decide which option is best for you.`,
  },

  {
    title: "How can I improve my boiler's efficiency?",
    details: `To improve boiler efficiency, consider regular servicing, bleeding radiators, installing a thermostat, and using a timer. If your boiler is older, upgrading to a more energy-efficient model might be a smart move.`,
  },

  {
    title: 'What should I do if my boiler loses pressure?',
    details: `If your boiler's pressure gauge drops below 1 bar, you may need to re-pressurize it. Follow the manufacturer’s instructions or get in touch with our heating engineer. Persistent pressure loss may indicate a leak or another issue that requires professional attention.`,
  },
];
